export const features = [
    {
        "title": {
            "en": "Car Leasing",
            "es": "Arrendamiento de autos",
            "pt": "Leasing de carros"
        },
        "text": {
            "en": "Remarketing inspections",
            "es": "Inspecciones de recomercialización",
            "pt": "Inspeções de remarketing"
        },
        "img": "car-leasing.svg"
    },
    {
        "title": {
            "en": "Logistics",
            "es": "Logística",
            "pt": "Logística"
        },
        "text": {
            "en": "Damage assessment before & after transportation",
            "es": "Evaluación de daños antes y después del transporte.",
            "pt": "Avaliação de danos antes e depois do transporte"
        },
        "img": "logistics.svg"
    },
    {
        "title": {
            "en": "Dealers & Repair Shops",
            "es": "Distribuidores y talleres de reparación",
            "pt": "Concessionárias e oficinas de reparação"
        },
        "text": {
            "en": "Quick claim estimate",
            "es": "Estimación rápida de reclamos",
            "pt": "Estimativa rápida de sinistros"
        },
        "img": "dealers-repair-shops.svg"
    },
    {
        "title": {
            "en": "Rental Car Inspection",
            "es": "Inspección de coches de alquiler",
            "pt": "Inspeção de carros de aluguel"
        },
        "text": {
            "en": "Damage assessment before & after a journey",
            "es": "Evaluación de daños antes y después de un viaje.",
            "pt": "Avaliação de danos antes e depois de uma viagem"
        },
        "img": "car-rental.svg"
    },
    {
        "title": {
            "en": "Used Cars",
            "es": "Autos usados",
            "pt": "Carros usados"
        },
        "text": {
            "en": "Damage assessment and car valuation",
            "es": "Evaluación de daños y valoración del coche.",
            "pt": "Avaliação de danos e valorização do carro"
        },
        "img": "used-cars.svg"
    },
    {
        "title": {
            "en": "Salvage Vehicles",
            "es": "Vehículos de salvamento",
            "pt": "Veículos de salvamento"
        },
        "text": {
            "en": "Salvage value estimation",
            "es": "Estimación del valor de rescate",
            "pt": "Estimativa de valor de salvamento"
        },
        "img": "salvage-vehicles.svg"
    }
]